<template>
  <v-card>
    <v-toolbar flat>
      <span class="headline">Approve Notes</span>
      <v-spacer></v-spacer>
      <v-btn icon @click="hideDialog">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-layout row class="approved-tips" v-if="loanScore < 5">
      <v-flex lg12>
          <span class="approved-content">
            This loan has very high credit risk per Pre-Underwriter, do you really want to approve it?
          </span>
      </v-flex>
    </v-layout>
    <v-card-text>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-layout row wrap>
          <v-flex lg12 sm12>
            <v-textarea
              style="margin-left: 5px"
              textarea
              hide-details
              label="Description"
              v-model="notes"
              rows="4"
              row-height="30"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-card-actions class="pb-3">
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="saveNote">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { DataType, Tool } from '@/util/index'
const tool = new Tool()

export default {
  name: 'approve-dialog',
  props: {
    loanScore: Number
  },
  data () {
    return {
      valid: true,
      notes: '',
      status: DataType.LoanStatus
    }
  },
  methods: {
    saveNote () {
      if (tool.isEmpty(this.notes)) {
        this.$swal({ type: 'warning', text: 'Please enter note content', showCancelButton: false })
      } else {
        this.$emit('updateLoanStatus', this.status.APPROVED.value)
        this.hideDialog()
        this.notes = ''
      }
    },
    hideDialog () {
      this.$emit('hideDialog', 'APPROVE')
    }
  }
}
</script>

<style lang="css" scoped>
.approved-tips {
  margin-top: 5px;
  width: 700px;
  margin-left: 15px;
}
.approved-content {
  width: 650px;
  font-size: 16px;
}
</style>
